import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import { Vue as SentryVue}  from '@sentry/integrations';
import {loadCSS} from 'fg-loadcss'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://133efd334b724b47b5c203b5d116ceaf@sentry.io/1767112',
    integrations: [new SentryVue({Vue, attachProps: true})],
  });
}

require('./vendor/jquery-with-plugins')

window.JS_MODULES.forEach(script => {
  import(/* webpackChunkName: "assets/jsc/[request]" */ `./lazy-modules/${script}`)
})

// old scripts
import './handlers/index'
//
// // vue app
import './app/app'
import onWindowLoad, {onWindowLoadAndIdle} from "@MAIN/vendor/onWindowLoad";

async function loadScriptAndStyleDefer() {
  await onWindowLoadAndIdle
  await import(/*webpackPreload: true, webpackChunkName: "assets/jsc/script-defer" */ `./script-defer`)

  if (global.CSS_DEFER_PATH)
  {
    loadCSS(global.CSS_DEFER_PATH)
  }
}

loadScriptAndStyleDefer()
